class SeoObject {
  constructor(title, description) {
    this.title = title;
    this.description = description;
  }
}
export default SeoObject;
